import React from "react";
import { Typography } from "@mui/material";
import { PromptDialog } from "../../../components/molecules";
import useTerms from "../../../hooks/useTerms";

export default function CancelDialog({ open, onClose, onConfirm, isCancelling }) {
  const terms = useTerms();
  const handleClose = () => {
    if (isCancelling) return;
    onClose();
  };

  // PromptDialog kırpılmış metni verir; boş gerekçe eskisi gibi null gider.
  const handleConfirm = async (reason) => {
    await onConfirm(reason || null);
  };

  return (
    <PromptDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={`${terms.examAcc} İptal Et`}
      message={
        <Typography sx={{ fontSize: "0.9rem" }}>
          {terms.exam} iptal edilecek. Bu süreçte girdiğiniz kayıtlar sistemde{" "}
          <b>iptal edilmiş {terms.examLower}</b> damgası ile saklanacak. Randevu{" "}
          <b>bekleniyor</b> durumuna geri döner ve istediğiniz zaman tekrar
          {terms.examLower} başlatabilirsiniz.
        </Typography>
      }
      inputLabel="İptal sebebi (opsiyonel)"
      minRows={3}
      cancelText="Vazgeç"
      confirmText={`${terms.examAcc} İptal Et`}
      confirmVariant="error"
      loading={isCancelling}
      loadingText="İptal Ediliyor..."
    />
  );
}
